import { j as r } from "./jsx-runtime-944c88e2.js";
import { Spinner as s } from "./spinner.js";
import { Error as p } from "./error.js";
import "react";
import "./icon.js";
import "./index-efd35e77.js";
import "./typography.js";
import "./index-c07310bf.js";
import "./index-64063129.js";
import "react-dom";
import "./auto-scroll-b2de6e53.js";
import "./button.js";
import "./Button-4c83e316.js";
import "./package-metadata-9ad1330d.js";
import "./theme-b013fa81.js";
import "./Ripple-5a8cf54c.js";
const q = ({
  status: i,
  children: o,
  refetch: m,
  LoadingComponent: t,
  ErrorComponent: e
}) => i === "success" ? o : i === "error" ? e ? /* @__PURE__ */ r.jsx(e, {}) : /* @__PURE__ */ r.jsx(p, { refresh: m }) : i === "loading" ? t ? /* @__PURE__ */ r.jsx(t, {}) : /* @__PURE__ */ r.jsx(
  "div",
  {
    style: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    children: /* @__PURE__ */ r.jsx(
      "div",
      {
        style: {
          height: "100vh",
          width: "40%"
        },
        children: /* @__PURE__ */ r.jsx(s, { size: "auto" })
      }
    )
  }
) : /* @__PURE__ */ r.jsx("div", { children: "Something has gone wrong." });
export {
  q as RequestState
};
